import { Component } from '@angular/core';
import { ProductDeleteIconComponent as ProductDeleteIconBaseComponent } from 'projects/shared/lib/components/shared/product/delete-icon/product-delete-icon.component';

@Component({
    selector: 'app-product-delete-icon',
    templateUrl: './product-delete-icon.component.html',
    standalone: false
})
export class ProductDeleteIconComponent extends ProductDeleteIconBaseComponent { }
